import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import { User } from '@utils/backend-api/currentUser';

import Benefits from './Benefits';
import CTAAndTestimonials from './CTAAndTestimonials';
import Education from './Education';
import Header from './Header';
import IntroAndForm from './IntroAndForm';
import Licensing from './Licensing';

const queryClient = new QueryClient();

interface CorporateLandingProps {
  env: Env;
  initialCurrentUser?: User;
  isWebview: boolean;
}

const CorporateLanding = ({ env, initialCurrentUser, isWebview }: CorporateLandingProps) => {
  return (
    <AppContextProvider env={env} initialCurrentUser={initialCurrentUser} isWebview={isWebview}>
      <QueryClientProvider client={queryClient}>
        <Header />
        <IntroAndForm />
        <Benefits />
        <CTAAndTestimonials />
        <Education />
        <Licensing />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default CorporateLanding;
